import "./index.css";
export const Loader = () => {
  return (
    <>
      <span className="loader flex w-full justify-center items-center"></span>
    </>
  );
};
